import ComicCard from '@/components/base/ComicCard';
import type { Comic } from '@/mocks/comics';
import { Link } from 'react-router-dom';

interface PopularSectionProps {
  title: string;
  subtitle?: string;
  comics: Comic[];
  viewAllLink?: string;
}

export default function PopularSection({ title, subtitle, comics, viewAllLink }: PopularSectionProps) {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-10 md:mb-14">
          <div>
            <span className="text-xs font-medium tracking-widest uppercase text-secondary-500">
              热门推荐
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mt-3">
              {title}
            </h2>
            {subtitle && (
              <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>
            )}
          </div>
          {viewAllLink && (
            <Link
              to={viewAllLink}
              className="whitespace-nowrap hidden sm:inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          )}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {comics.slice(0, 10).map((comic, index) => (
            <ComicCard
              key={comic.id}
              comic={comic}
              badge={index === 0 ? '独家首发' : undefined}
            />
          ))}
        </div>

        {viewAllLink && (
          <div className="mt-8 text-center sm:hidden">
            <Link
              to={viewAllLink}
              className="whitespace-nowrap inline-flex items-center gap-1 text-sm text-primary-500 font-medium"
            >
              查看全部
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}